import { render, staticRenderFns } from "./patientIntegrationProduce.vue?vue&type=template&id=103e8624&scoped=true"
import script from "./patientIntegrationProduce.vue?vue&type=script&lang=js"
export * from "./patientIntegrationProduce.vue?vue&type=script&lang=js"
import style0 from "./patientIntegrationProduce.vue?vue&type=style&index=0&id=103e8624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103e8624",
  null
  
)

export default component.exports